import config from '../../config';
import { S3Client, ListObjectsCommand, CopyObjectCommand, PutObjectCommand, GetObjectAclCommand, PutObjectAclCommand, GetObjectCommand } from '@aws-sdk/client-s3';
import { getSignedUrl } from '@aws-sdk/s3-request-presigner';
import { apiClient } from './apiClient';

const getAllAccordions = async function(searchText, activeOnly, mediaPropertyID, sharedDetailID, mediaTypeID) {
    var url;      
    var parms = ''; 
    if(mediaPropertyID == null) mediaPropertyID = 0;
    if(sharedDetailID == null) sharedDetailID = 0;
    if(mediaTypeID == null) mediaTypeID = 0;

    url = "/accordion"
    if(searchText != '') parms += "&search_text=" + searchText;
    if(activeOnly != '') parms += "&active_only=" + activeOnly;
    if(mediaPropertyID > 0) parms += "&media_property=" + mediaPropertyID;
    if(sharedDetailID > 0) parms += "&shared_accordion_detail_id=" + sharedDetailID;
    if(mediaTypeID > 0) parms += "&media_type=" + mediaTypeID;
    if(parms.length > 0) parms = '?' + parms.slice(1);

    return await apiClient.get(url + parms);
}

const getAccordion = async function(id, code, returnActiveRecordOnly = true) {
    var payload = {
       activeOnly: returnActiveRecordOnly 
    }

    var response; 
    if(id > 0)
        response = await apiClient.post("/accordion/load-by-id/" + id, payload);
    else
        response =  apiClient.post("/accordion/load-by-code/" + code, payload);

    if(response.success)
        return response.data;
    else 
        return response;
}

const getAccordionWithParameters = async function(code, parameters) {
    const params = new URLSearchParams([['displayParams',  JSON.stringify(parameters)]]);
    const response = await apiClient.get("/accordion/GetByCode/" + code, { params });
    return response.data;
}

const saveAccordion = async function(accordion) {
    if(accordion.id)
        return await apiClient.patch("/accordion/" + accordion.id, accordion);
    else
        return await apiClient.post("/accordion", accordion);
}

const deleteAccordion = async function(accordionId) {
    return await apiClient.remove("/accordion/" + accordionId);
}

const copyAccordion = async function(id) {
    var result = {};

    await apiClient.get('/accordion/' + id + '/copy')
    .then((data) => {
        result = data; 
    })
    .catch((error) => { result.errors = ProcessSaveErrors(error.response.data.errors)  });

    return result;
}

const saveAccordionSection = async function(accordionId, section) {
    if(section.id)
        return await apiClient.patch('/accordion/' + accordionId + '/section/' + section.id, section);
    else
        return await apiClient.post('/accordion/' + accordionId + '/section/', section);
    
}

const deleteAccordionSection = async function(accordionId, sectionId) {
    return await apiClient.remove("/accordion/" + accordionId + '/section/' + sectionId);
}

const saveAccordionHeader = async function(accordionId, sectionId, header) {
    if(header.id)
        return await apiClient.patch('/accordion/' + accordionId + '/section/' + sectionId + '/header/' + header.id, header);
    else
        return await apiClient.post('/accordion/' + accordionId + '/section/' + sectionId + '/header/', header);
}

const deleteAccordionHeader = async function(accordionId, sectionId, headerId) {
    return await apiClient.remove("/accordion/" + accordionId + '/section/' + sectionId + '/header/' + headerId);
}

const getAccordionDetail  = async function(accordionId, sectionId, id) {
    if(id)
        return await apiClient.get('/accordion/' + accordionId + '/section/' + sectionId + '/detail/' + id);
}

const saveAccordionDetail = async function(accordionId, sectionId, detail) {
    if(detail.id)
        return await apiClient.patch('/accordion/' + accordionId + '/section/' + sectionId + '/detail/' + detail.id, detail);
    else
        return await apiClient.post('/accordion/' + accordionId + '/section/' + sectionId + '/detail/', detail);
}

const deleteAccordionDetail = async function(accordionId, sectionId, detailId) {
    return await apiClient.remove("/accordion/" + accordionId + '/section/' + sectionId + '/detail/' + detailId);
}

const saveAccordionExtraText = async function(accordionId, extraText) {
    if(extraText.id)
        return await apiClient.patch('/accordion/' + accordionId + '/extra_text/' + extraText.id, extraText);
    else
        return await apiClient.post('/accordion/' + accordionId + '/extra_text/', extraText);
}

const deleteAccordionExtraText = async function(accordionId, id) {
    return await apiClient.remove("/accordion/" + accordionId + '/extra_text/' + id);
}

const getAllClients = async function(searchText, activeOnly) {
    const ret =  await apiClient.get("/Client?search_text=" + searchText + "&active_only=" + activeOnly);
    return ret;
}

const getClient = async function(id) {
    return await apiClient.get("/Client/" + id);
}

const saveClient = async function(client) {
    if(client.id)
        return await apiClient.patch("/Client/" + client.id, client);
    else
        return await apiClient.post("/Client", client);
}

const deleteClient = async function(clientId) {
    return await apiClient.remove("/client/" + clientId);
}

const saveClientAccess = async function(clientAccess) {
    if(clientAccess.id)
        return await apiClient.patch('/client/' + clientAccess.clientId + '/access/' + clientAccess.id, clientAccess);
    else
        return await apiClient.post('/client/' + clientAccess.clientId + '/access/', clientAccess);
}

const deleteClientAccess = async function(clientId, clientAccessId) {
    return await apiClient.remove('/client/' + clientId + '/access/' + clientAccessId);
}

const getAllSurveys = async function(searchText, activeOnly, mediaPropertyID = 0, mediaTypeID = 0) {
    var url;      
    var parms = ''; 
    if(mediaPropertyID == null) mediaPropertyID = 0;
    if(mediaTypeID == null) mediaTypeID = 0;

    url = "/survey?"
    if(searchText != '') parms += "&search_text=" + searchText;
    if(activeOnly != '') parms += "&active_only=" + activeOnly;
    if(mediaPropertyID > 0) parms += "&media_property=" + mediaPropertyID;
    if(mediaTypeID > 0) parms += "&media_type=" + mediaTypeID;

    return await apiClient.get(url + parms.slice(1));
}

const getSurvey = async function(id, code, returnActiveRecordOnly = true) {
    let resp;
    if(id > 0)
        resp = await apiClient.post("/survey/load-by-id/" + id);
    else
        resp = await apiClient.post("/survey/load-by-code/" + code, { returnActiveRecordOnly: returnActiveRecordOnly });
    
    if(resp.success)
        return resp.data;
    else 
        return resp;
}

const saveSurvey = async function(survey) {
    if(survey.id)
        return await apiClient.patch("/survey/" + survey.id, survey);
    else
        return await apiClient.post("/survey", survey);
}

const deleteSurvey = async function(surveyId) {
    return await apiClient.remove("/survey/" + surveyId);
}

const browseSurveysByQuestionId = async function(questionId) {
    return await apiClient.get('/survey/BrowseByQuestionId/' + questionId);
}

const copySurvey = async function(id) {
    var result = {};

    await apiClient.get('/survey/' + id + '/copy')
    .then((data) => {
        result = data; 
    })
    .catch((error) => { result.errors = ProcessSaveErrors(error.response.data.errors)  });

    return result;
}

const saveSurveyQuestion = async function(surveyId, surveyPageId, surQues) {
    if(surQues.id)
        return await apiClient.patch("/survey/" + surveyId + "/page/" + surveyPageId + "/question/" + surQues.id, surQues);
    else
        return await apiClient.post("/survey/" + surveyId + "/page/" + surveyPageId + "/question", surQues);
}

const reorderSurveyQuestions = async function(surveyID, surveyPageID, sequenceToMove, newSequence) {
    return await apiClient.get("/survey/" + surveyID + "/page/" + surveyPageID + "/question/Reorder?sequenceToMove=" + sequenceToMove + "&newSequence=" + newSequence);
}

const deleteSurveyQuestion = async function(surId, surveyPageId, surQuesId) {
    return await apiClient.remove("/survey/" + surId + "/page/" + surveyPageId + "/question/" + surQuesId);
}

const browseSurveyQuestionByLogActivityTypeCode = async function(code) {
    return await apiClient.get('/survey/0/page/0/question/GetByLogActivityTypeCode/' + code);
}

const saveSurveyPage = async function(surveyId, page) {
    //we do not want to save a blank breadcrumb configuration because that will fail validation.   Null means nothing will be save and we are good.
    if(page.configuration &&
            page.configuration.breadcrumbConfiguration && 
            page.configuration.breadcrumbConfiguration.title == '' &&
            page.configuration.breadcrumbConfiguration.number == '')
        page.configuration.breadcrumbConfiguration = null;

    var retVal; 

    if(page.id)
        retVal = await apiClient.patch("/survey/" + surveyId + "/page/" + page.id, page);
    else
        retVal =  await apiClient.post("/survey/" + surveyId + "/page", page);

    //put the blank breadcrumb back after the save
    if(page.configuration && page.configuration.breadcrumbConfiguration == null)
        page.configuration.breadcrumbConfiguration = {
        number: '',
        title: ''
    }

    return retVal;
}

const deleteSurveyPage = async function(surveyId, pageId) {
    return await apiClient.remove("/survey/" + surveyId + "/page/" + pageId);
}

const reorderSurveyPages = async function(surveyID, pageNumberToMove, newPageNumber) {
    return await apiClient.get("/survey/" + surveyID + "/page/ReorderPages?pageNumberToMove=" + pageNumberToMove + "&newPageNumber=" + newPageNumber);
}


const getAllQuestions = async function(activeOnly) {
    return await apiClient.get("/question?&active_only=" + activeOnly);
}

const getQuestion = async function(id) {
    return await apiClient.get("/question/" + id + "?returnActiveRecordOnly=false");
}

const saveQuestion = async function(question) {
    if(question.id)
        return await apiClient.patch("/question/" + question.id, question);
    else
        return await apiClient.post("/question", question);
}

const deleteQuestion = async function(questionId) {
    return await apiClient.remove("/question/" + questionId);
}


const saveAnswer = async function(questionId, answer) {
    if(answer.id)
        return await apiClient.patch("/question/" + questionId + "/answer/" + answer.id, answer);
    else
        return await apiClient.post("/question/" + questionId + "/answer", answer);
}

const deleteAnswer = async function(questionId, answerId) {
    return await apiClient.remove("/question/" + questionId + "/answer/" + answerId);
}


const saveSurveyAction = async function(surveyAction) {
    if(surveyAction.id)
        return await apiClient.patch("/survey/" + surveyAction.surveyId + "/surveyaction/" + surveyAction.id, surveyAction);
    else
        return await apiClient.post("/survey/" + surveyAction.surveyId + "/surveyaction/", surveyAction);
}

const deleteSurveyAction = async function(surveyAction) {
    return await apiClient.remove("/survey/" + surveyAction.surveyId + "/surveyaction/" + surveyAction.id);
}

const reorderSurveyActions = async function(surveyID, surveyPageID, actionType, sequenceToMove, newSequence) {
    return await apiClient.get("/survey/" + surveyID + "/surveyaction/Reorder?surveyPageID=" + surveyPageID + "&actionType=" + actionType + "&sequenceToMove=" + sequenceToMove + "&newSequence=" + newSequence);
}

const reorderAccordionActions = async function(accordionID, accordionSectionID, actionType, sequenceToMove, newSequence) {
    return await apiClient.get(`/accordion/${accordionID}/accordionaction/Reorder?${accordionSectionID ? "accordionSectionID=" + accordionSectionID : '' }&actionType=${actionType}&sequenceToMove=${sequenceToMove}&newSequence=${newSequence}`);
}

const getEnumList = async function(enumName, returnNotSetTF = true) {
    return await apiClient.get("/enum/GetEnumList/" + enumName + '?includeNotSet=' + returnNotSetTF )
}

const getAllAttributes = async function(searchText, activeOnly) {
    return await apiClient.get("/attribute?search_text=" + searchText + "&active_only=" + activeOnly);
}

const getReplacementStringAttributes = async function() {
    return await apiClient.get("/attribute?replacement_strings_only=true");
}

const getAttribute = async function(id) {
    return await apiClient.get("/attribute/" + id);
}

const saveAttribute = async function(attribute) {
    if(attribute.id)
        return await apiClient.patch("/attribute/" + attribute.id, attribute);
    else
        return await apiClient.post("/attribute", attribute);
}

const deleteAttribute = async function(attributeId) {
    return await apiClient.remove("/attribute/" + attributeId);
}

const getMediaProperty = async function(mediaPropertyId) {
    return await apiClient.get("/mediaproperty/" + mediaPropertyId);
}

const getAllMediaProperties = async function(searchText, activeOnly) {
    return await apiClient.get("/mediaproperty?search_text=" + searchText + "&active_only=" + activeOnly);
}

const getMediaPropertiesByMediaType = async function(mediaType) {
    return await apiClient.get("/mediaproperty/getbymediatype/" + mediaType);
}

const saveMediaProperty = async function(mediaProperty) {
    if(mediaProperty.id)
        return await apiClient.patch("/mediaproperty/" + mediaProperty.id, mediaProperty);
    else
        return await apiClient.post("/mediaproperty", mediaProperty);
}

const deleteMediaProperty = async function(mediaPropertyId) {
    return await apiClient.remove("/mediaproperty/" + mediaPropertyId);
}

const copyMediaProperty = async function(id) {
    var result = {};

    await apiClient.get('/mediaproperty/' + id + '/copy')
    .then((data) => {
        result = data; 
    })
    .catch((error) => { result.errors = ProcessSaveErrors(error.response.data.errors)  });

    return result;
}

const getLogActivityType = async function(id) {
    return await apiClient.get('/logactivitytype/' + id);
}

const saveLogActivityType = async function(logActivityType) {
    if(logActivityType.id)
        return await apiClient.patch("/logactivitytype/" + logActivityType.id, logActivityType);
    else
        return await apiClient.post("/logactivitytype/", logActivityType);
}

const getLogActivityTypes = async function(searchText, activeOnly) {
    return await apiClient.get("/logActivityType?search_text=" + searchText + "&active_only=" + activeOnly);
}

const deleteLogActivityType = async function(id) {
    return await apiClient.remove("/logActivityType/" + id);
}

const getFeedbackSubject = async function(id) {
    return await apiClient.get("/feedbackSubject/" + id);
}

const getFeedbackSubjects = async function(searchText, activeOnly) {
    return await apiClient.get("/feedbackSubject?search_text=" + searchText + "&active_only=" + activeOnly);
}

const saveFeedbackSubject = async function(values) {
    if(values.id)
        return await apiClient.patch( "/feedbackSubject/" + values.id, values);
    else
        return await apiClient.post("/feedbackSubject", values);
}

const deleteFeedbackSubject = async function(id) {
    return await apiClient.remove("/feedbackSubject/" + id);
}

const getTag = async function(id) {
    return await apiClient.get('/tag/' + id);
}

const saveTag = async function(value) {
    if(value.id)
        return await apiClient.patch("/tag/" + value.id, value);
    else
        return await apiClient.post("/tag/", value);
}

const getTags = async function(searchText, tagType, activeOnly) {
    return await apiClient.get("/tag?search_text=" + searchText + "&tag_type=" + tagType + "&active_only=" + activeOnly);
}

const deleteTag = async function(id) {
    return await apiClient.remove("/tag/" + id);
}

const getSharedDetails = async function(searchText) {
    return await apiClient.get("/sharedAccordionDetail?search_text=" + searchText );
}

const getSharedDetail = async function(id) {
    return await apiClient.get('/sharedAccordionDetail/' + id);
}

const saveSharedDetail = async function(value) {
    if(value.id)
        return await apiClient.patch("/sharedAccordionDetail/" + value.id, value);
    else
        return await apiClient.post("/sharedAccordionDetail/", value);
}

const deleteSharedDetail = async function(id) {
    return await apiClient.remove("/sharedAccordionDetail/" + id);
}

const getTestConfiguration = async function(id) {
    return await apiClient.get("/testconfiguration/" + id);
}

const getTestConfigurationByAccordionId = async function(accId) {
    return await apiClient.get("/testconfiguration/LoadByAccordionId/" + accId);
}

const saveTestConfiguration = async function(value) {
    if(value.id)
        return await apiClient.patch('/testconfiguration/' + value.id, value);
    else
        return await apiClient.post('/testconfiguration/', value);
}

const deleteTestConfiguration = async function(id) {
    return await apiClient.remove('/testconfiguration/' + id);
}

const getTestScenario = async function(id, testConfigurationId) {
    return await apiClient.get("/testconfiguration/" + testConfigurationId + "/scenario/" + id);
}

const saveTestScenario = async function(value) {
    if(value.id)
        return await apiClient.patch('/testconfiguration/' + value.testConfigurationId + '/scenario/' + value.id, value);
    else
        return await apiClient.post('/testconfiguration/' + value.testConfigurationId + '/scenario/', value);
}

const deleteTestScenario = async function(id, testConfigurationId) {
    return await apiClient.remove('/testconfiguration/' + testConfigurationId + '/scenario/' + id);
}

const saveTestScenarioData = async function(value, testConfigurationId) {
    if(value.id)
        return await apiClient.patch('/testconfiguration/' + testConfigurationId + '/scenario/' + value.testScenarioID + '/data/' + value.id, value);
    else
        return await apiClient.post('/testconfiguration/' + testConfigurationId + '/scenario/' + value.testScenarioID + '/data/', value);
}

const deleteTestScenarioData = async function(id, testConfigurationID, testScenarioID) {
    return await apiClient.remove('/testconfiguration/' + testConfigurationID + '/scenario/' + testScenarioID + '/data/' + id);
}

const getAuth0Log = async function(startDate = null, endDate = null) {
    var sendObject = {
        'startDate': startDate,
        'endDate': endDate,
        'apiKey': config.apiKey
    }

    var result = [];

    await apiClient.post("/Auth0/logs/", sendObject)
        .then( (response) => {  result = response.data; });
    
    return result;
}

const getActivityLogs = async function(clientCode, startDate = null, endDate = null) {
    var sendObject = {
        'startDate': startDate,
        'endDate': endDate
    }

    var result = [];

    await apiClient.post("/reporting/activityLogs/" + clientCode, sendObject)
        .then( (response) => {  result = response.data; });
    
    return result;
}

const getClientFeedback = async function(clientCode, startDate = null, endDate = null) {
    var sendObject = {
        'startDate': startDate,
        'endDate': endDate
    }

    var result = [];

    await apiClient.post("/reporting/feedback/" + clientCode, sendObject)
        .then( (response) => {  result = response.data; });
    
    return result;
}

const getAccordionAction = async function(accordionID, accordionActionID) {
    return await apiClient.get("/accordion/" + accordionID + "/accordionaction/" + accordionActionID);
}

const saveAccordionAction = async function(accordionAction, accordionID) {
    if(accordionAction.id)
        return await apiClient.patch("/accordion/" + accordionID + "/accordionaction/" + accordionAction.id, accordionAction);
    else
        return await apiClient.post("/accordion/" + accordionID + "/accordionaction/", accordionAction);
}

const deleteAccordionAction = async function(accordionAction, accordionID) {
    return await apiClient.remove("/accordion/" + accordionID + "/accordionaction/" + accordionAction.id);
}

const getAITranscription = async function(id) {
    return await apiClient.get("/aitranscription/" + id);
}

const getAllAITranscriptions = async function() {
    return await apiClient.get("/aitranscription/getAllAITranscriptions");
}

const browseAITranscriptionsByMediaPropertyId = async function(mpId) {
    return await apiClient.get("/aitranscription/BrowseByMediaPropertyId/" + mpId);
}

const saveAITranscription = async function(ait) {
    if(ait.id)
        return await apiClient.patch("/aitranscription/" + ait.id, ait);
    else
        return await apiClient.post("/aitranscription/", ait);
}

const deleteAITranscription = async function(id) {
    return apiClient.remove("/aitranscription/" + id);
}

const submitMediaForTranscription = async function(mediaPropertyID, url, languageCode) {
    const reqBody = {
        mediaPropertyID: mediaPropertyID,
        // Full URL
        url: url,
        // "en" = English, "es" = Spanish, "pt" = Portuguese, "fr" = French
        languageCode: languageCode
    };
    return await apiClient.post("/aitranscription/transcribe/", reqBody)
}

const copyStorageObject = async function(saveObject) {
    let response = {
        success: false,
        errors: null
    }

    const s3 = new S3Client({
        endpoint: config.fileStorageUrl,
        region: config.wasabiRegion,
        credentials: {
            accessKeyId: config.wasabiAccessKeyId,
            secretAccessKey: config.wasabiSecretAccessKey
        }
    });
    
    const objects = await s3.send(new ListObjectsCommand({
        Prefix: saveObject.fromFolder + '/',
        Bucket: saveObject.fromBucket
    }));

    try {
        await Promise.all(objects.Contents.map(async (fileInfo) => {
            await s3.send(new CopyObjectCommand({
                Bucket: saveObject.toBucket,
                CopySource: `${saveObject.fromBucket}/${fileInfo.Key}`,
                Key: `${saveObject.toFolder}/${fileInfo.Key.replace(objects.Prefix, '')}`,
                ACL: 'public-read'
            }));
        }));
        response.success = true;
        return response;
    } catch (err) {
        response.errors = err;
        return response;
    }
}

const translateText = async function(text, languageArray, defaultLanguage) {
    let data = {
        text: text,
        languages: languageArray,
        defaultLanguage: defaultLanguage
    };
    let result = {
        success: false,
        returnArr: null
    }
    await apiClient.post('/Translation/TranslateText', data)
                .then((res) => { 
                    result.success = true; 
                    result.returnArr = res.data; 
                });
    
    return result.returnArr;
}

const getLanguages = async function() {
    return await apiClient.get('/language/');
}

const uploadStorageObject = async function(objectBlob, bucket, key, publicPermission) {
    let response = {
        success: false,
        errors: null
    };

    const s3 = new S3Client({
        endpoint: config.fileStorageUrl,
        region: config.wasabiRegion,
        credentials: {
            accessKeyId: config.wasabiAccessKeyId,
            secretAccessKey: config.wasabiSecretAccessKey
        },
        // It's a known issue that the latest version of AWS SDK will throw a 
        // 'readableStream.getReader is not a function' error without the following.
        // https://github.com/aws/aws-sdk-js-v3/issues/6834#issuecomment-2613306914
        requestChecksumCalculation: "WHEN_REQUIRED",
    });
    
    try {
        await s3.send(new PutObjectCommand({
            Bucket: bucket,
            Key: key,
            Body: objectBlob,
            ACL: publicPermission,
            CacheControl: 'no-cache'
        }));
        response.success = true;
        return response;
    } catch(err) {
        response.errors = err;
        return response;
    }
}

const getStorageObjectPermissions = async function(bucket, key) {
    let response = {
        success: false,
        errors: null,
        data: null
    };

    const s3 = new S3Client({
        endpoint: config.fileStorageUrl,
        region: config.wasabiRegion,
        credentials: {
            accessKeyId: config.wasabiAccessKeyId,
            secretAccessKey: config.wasabiSecretAccessKey
        }
    });
    
    try {
        const resp = await s3.send(new GetObjectAclCommand({
            Bucket: bucket,
            Key: key
        }));
        response.success = true;
        response.data = resp;
        return response;
    } catch(err) {
        response.errors = err;
        return response;
    }
}

const updateStorageObjectPermissions = async function(bucket, key, publicPermission) {
    let response = {
        success: false,
        errors: null
    };

    const s3 = new S3Client({
        endpoint: config.fileStorageUrl,
        region: config.wasabiRegion,
        credentials: {
            accessKeyId: config.wasabiAccessKeyId,
            secretAccessKey: config.wasabiSecretAccessKey
        }
    });
    
    try {
        await s3.send(new PutObjectAclCommand({
            Bucket: bucket,
            Key: key,
            ACL: publicPermission
        }));
        response.success = true;
        return response;
    } catch(err) {
        response.errors = err;
        return response;
    }
}

const getSignedStorageUrl = async function(bucket, fileKey) {
    let response = {
        success: false,
        errors: null,
        data: null
    };

    const s3 = new S3Client({
        endpoint: config.fileStorageUrl,
        region: config.wasabiRegion,
        credentials: {
            accessKeyId: config.wasabiAccessKeyId,
            secretAccessKey: config.wasabiSecretAccessKey
        }
    });
    
    try {
        const command = new GetObjectCommand({
            Bucket: bucket,
            Key: fileKey
        });
        const resp = await getSignedUrl(s3, command, {expiresIn: config.mediaUrlExpirationInSeconds});
        response.success = true;
        response.data = resp;
        return response;
    } catch(err) {
        response.errors = err;
        return response;
    }
}

const ProcessSaveErrors = function (errors) {
    if(typeof(errors) === "string")
        return [errors];
    
    var retErrors = []
    for (var key in errors) {
        if (Object.prototype.hasOwnProperty.call(errors, key)) {
            var val = errors[key];
            for(var j = 0; j < val.length; j++)
            {
                retErrors.push(key + ' ' + val[j]);
            }
        }
    }

    return retErrors;
}

const getLmsData = async function(courseId, searchStartDate = null, searchEndDate = null) {    
    var sendObject = {
        'courseId': courseId,
        'startDate': searchStartDate,
        'endDate': searchEndDate
    }

    var result = [];

    await apiClient.post("/lms/GetLmsInteractions", sendObject)
        .then( (response) => {  result = response.data; });
    
    return result;
}

export const data = {
    getAllAccordions,
    getAccordion,
    getAccordionWithParameters,
    saveAccordion,
    deleteAccordion,
    saveAccordionSection,
    deleteAccordionSection,
    saveAccordionHeader,
    deleteAccordionHeader,
    saveAccordionDetail,
    deleteAccordionDetail,
    getAllClients,
    getClient,
    saveClient,
    deleteClient,
    saveClientAccess,
    deleteClientAccess,
    getAllSurveys,
    getSurvey,
    saveSurvey,
    deleteSurvey,
    browseSurveysByQuestionId,
    saveSurveyQuestion,
    deleteSurveyQuestion,
    browseSurveyQuestionByLogActivityTypeCode,
    getAllQuestions,
    getQuestion,
    saveQuestion,
    deleteQuestion,
    saveAnswer,
    deleteAnswer,
    saveSurveyAction,
    deleteSurveyAction,
    getEnumList,
    getAllAttributes,
    getAttribute,
    saveAttribute,
    deleteAttribute,
    saveAccordionExtraText,
    deleteAccordionExtraText,
    getMediaProperty,
    getAllMediaProperties,
    getMediaPropertiesByMediaType,
    saveMediaProperty,
    deleteMediaProperty,
    copyMediaProperty,
    getLogActivityType,
    getLogActivityTypes,
    saveLogActivityType,
    deleteLogActivityType,
    getFeedbackSubject,
    getFeedbackSubjects,
    saveFeedbackSubject,
    deleteFeedbackSubject,
    getTag,
    saveTag,
    getTags,
    deleteTag,
    getSharedDetails,
    getSharedDetail,
    deleteSharedDetail,
    saveSharedDetail,
    saveSurveyPage,
    deleteSurveyPage,
    reorderSurveyPages,
    getTestConfiguration,
    getTestConfigurationByAccordionId,
    saveTestConfiguration,
    deleteTestConfiguration,
    getTestScenario,
    saveTestScenario,
    deleteTestScenario,
    saveTestScenarioData,
    deleteTestScenarioData,
    getReplacementStringAttributes,
    getActivityLogs,
    getClientFeedback,
    getLmsData, 
    copyAccordion,
    copySurvey,
    getAccordionDetail,
    getAccordionAction,
    saveAccordionAction,
    deleteAccordionAction,
    reorderSurveyQuestions,
    reorderSurveyActions,
    copyStorageObject,
    translateText,
    getLanguages,
    uploadStorageObject,
    getStorageObjectPermissions,
    updateStorageObjectPermissions,
    getSignedStorageUrl,
    reorderAccordionActions,
    getAITranscription,
    getAllAITranscriptions,
    browseAITranscriptionsByMediaPropertyId,
    saveAITranscription,
    deleteAITranscription,
    submitMediaForTranscription,
    getAuth0Log
}